/* Shared transport and feedback for predictive search and collection filters.
   Wortlaut und Typografie der Zustandstexte folgen der Hausregel im Kopf von
   assets/ivoodoo-forms.css (Block B, 12.09.2026). */
(function () {
  'use strict';
  if (window.ivAsyncUI) return;
  function text(key) { return theme.asyncStrings[key]; }
  function load(url) {
    const controller = new AbortController();
    let timer;
    const deadline = new Promise((resolve, reject) => {
      timer = window.setTimeout(() => {
        reject(new Error('Request timeout'));
        controller.abort();
      }, 12000);
    });
    const response = fetch(url, { signal: controller.signal }).then(result => {
      if (!result.ok) throw new Error('HTTP ' + result.status);
      return result.text();
    });
    return {
      promise: Promise.race([response, deadline]).finally(() => window.clearTimeout(timer)),
      cancel() { window.clearTimeout(timer); controller.abort(); }
    };
  }
  function feedback(retry, withSearchLink = false) {
    const root = document.createElement('div');
    root.className = 'iv-async-feedback';
    const status = document.createElement('p');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    status.setAttribute('aria-atomic', 'true');
    const actions = document.createElement('div');
    actions.className = 'iv-async-feedback__actions';
    actions.hidden = true;
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = text('retry');
    button.addEventListener('click', retry);
    actions.append(button);
    const link = withSearchLink ? document.createElement('a') : null;
    if (link) { link.textContent = text('allResults'); actions.append(link); }
    root.append(status, actions);
    return {
      root, button,
      set(message, state = 'idle', query = '') {
        root.dataset.state = state;
        status.textContent = message;
        // Block B (12.09.2026): Die Erfolgsmeldung wird nur noch angesagt, nicht mehr angezeigt -
        // sie hat die Vorschlagsliste und das Produktraster um 55 px verschoben. Der Kasten bleibt
        // im DOM mit role="status" und aria-live="polite". Laden und Fehler bleiben sichtbar.
        const still = state === 'success' || (state === 'loading' && !root.contains(document.activeElement));
        root.classList.toggle('visually-hidden', still);
        // A retry keeps its focusable node until the response is settled.
        if (state !== 'loading') actions.hidden = state !== 'error';
        button.disabled = state === 'loading';
        // Zwei Wege zum selben Ziel vermeiden: Steht im Panel schon der Fusszeilenknopf
        // "Alle Ergebnisse anzeigen", bleibt hier nur "Erneut versuchen".
        if (link) link.hidden = Boolean(root.parentNode && root.parentNode.querySelector('#search-results-submit'));
        if (link) link.href = theme.routes.search_url + '?q=' + encodeURIComponent(query);
      }
    };
  }
  window.ivAsyncUI = { load, feedback, text };
})();
